import gql from 'graphql-tag'

export default gql`
  mutation OrderReceiptSend($id: ID!) {
    orderReceiptSend(id: $id)
  }
`
